import { FC, ReactNode } from 'react';
import { Typography } from 'antd';

interface CopyTextProps {
  copy?: string;
  text?: ReactNode;

}

const { Paragraph } = Typography;


const CopyText: FC<CopyTextProps> = ({ copy, text }) => {
  return (
    <Paragraph style={{ marginBottom: 0 }} copyable={{ text: copy }}>{text}</Paragraph>
  );
};

export default CopyText;
